module.exports = __webpack_public_path__ + "static/media/illo_reading.8ac9622d.png";